export const catalog = (state) => state.catalog || []

export const catalogLoading = (state) => state.catalogLoading

export const instances = (state) => state.instances || []

export const instancesLoading = (state) => state.instancesLoading

export const moduleForbidden = (state) => state.moduleForbidden

// Cruzamento catálogo × instâncias (estado do card — RF8.1). Retorna null quando o
// slug não tem instância — vira "sem instância" no agent-card (CTA Ativar).
export const instanceBySlug = (state) => (slug) => {
  const found = (state.instances || []).find((instance) => instance.slug === slug)
  return found || null
}

// Empty state de Meus Agentes.
export const hasInstances = (state) => (state.instances || []).length > 0
